import {useCallback} from 'react';
import {Container} from '@mui/material';
import {useSearchParams} from 'react-router';
import type {RootState} from 'store/types';
import {useAppStore} from 'store/hooks';
import {FlexBox, PrettyPrintJson, Ruler, Select} from 'components';
import {ConfirmButton} from 'components/button/ConfirmButton';

export const DebugScene = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const state = useAppStore().getState();

  const key = searchParams.get('key') ?? '';
  const keys = Object.keys(state).sort();
  const data = state[key as keyof RootState] ?? {};

  const deleteLocalState = useCallback(() => {
    localStorage.clear();
    location.reload();
  }, []);

  return (
    <Container color="info" sx={{m: 2}} maxWidth={'md'}>
      <FlexBox horizontal>
        <Select
          options={keys}
          onChange={newKey => setSearchParams({key: newKey})}
          value={key}
        />
      </FlexBox>
      <PrettyPrintJson json={data as string} />

      <Ruler spacing={2} />

      <ConfirmButton
        onConfirm={deleteLocalState}
        title={`Reset state!`}
        icon={'Delete'}
        width={'max-content'}
      />
    </Container>
  );
};
